export enum HIPAAConsent {
  'Yes' = 0,
  'No' = 1,
  'Unknown' = 2,
}
